import { getConfigName } from "@helpers/funciones";
import CotizadorAvanzaSolido from "@pages/producto/credito_simple/avanza_solido/CotizadorAvanzaSolido";
import CotizadorFinbra from "@pages/producto/credito_simple/finbra/CotizadorFinbra";
import CotizadorNowPorts from "@pages/producto/credito_simple/nowports/CotizadorNowPorts";
import CotizadorKapitalFlex from "@pages/producto/credito_simple/kapital_flex/CotizadorKapitalFlex";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { signOut } from "aws-amplify/auth";
import CotizadorProvidencia from "@pages/producto/credito_simple/providencia/CotizadorProvidencia";
import CotizadorKalapata from "@pages/producto/credito_simple/kalapata/Cotizador";
import CotizadorArraCapital from "@pages/producto/credito_simple/arra_capital/CotizadorArraCapital";
import CotizadorArrendaminetoLaniAuto from "@pages/producto/credito_simple/lanitauto/CotizadorArrendaminetoLaniAuto";
import CotizadorCredivive from "@pages/producto/credito_simple/credivive/CotizadorCredivive";


interface CotizadorProps {
  type?: string;
}

const cotizadoresPorTipo: Record<string, Record<string, React.FC>> = {
  credito_simple: {
    finbra: CotizadorFinbra,
    now_ports: CotizadorNowPorts,
    avanza_solido: CotizadorAvanzaSolido,
    kapital_flex: CotizadorKapitalFlex,
    providencia: CotizadorProvidencia,
    kalapata: CotizadorKalapata,
    sfi: CotizadorKalapata,
    afirme: CotizadorKalapata,
    santander: CotizadorKalapata,
    bbva: CotizadorKalapata,
    nafin: CotizadorKalapata,
    incredit: CotizadorKalapata,
    arra_capital: CotizadorArraCapital,
    lanitauto: CotizadorArrendaminetoLaniAuto,
    lendia_demo: CotizadorKalapata,
    banbajio: CotizadorKalapata,
    actinver: CotizadorKalapata,
    credivive: CotizadorCredivive,
  },
  arrendamiento: {
    lanitauto: CotizadorArrendaminetoLaniAuto,
  },
};

export const Cotizadores = (props: CotizadorProps) => {
  const configName = getConfigName(window.location.href);
  const cotizadorType = props.type ?? "credito_simple";
  const Component = cotizadoresPorTipo[cotizadorType]?.[configName];

  useEffect(() => {
    const logout = async () => {
      localStorage.clear();
      await signOut();
    };

    logout();
  }, []);

  if (!Component) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};
